<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height class="splashPage">
        <v-layout column justify-center align-center>
          <div class="splashInnerPnl">
            <v-flex>
              <h2>{{projectTitle}}</h2>
            </v-flex>
            <v-flex v-if="loading">
              <v-progress-circular indeterminate v-bind:size="50" color="primary"></v-progress-circular>
            </v-flex>
            <v-flex v-else>
              <v-btn color="primary" @click="reloadPage">Reload Application</v-btn>
            </v-flex>
            <v-flex class="pt-3">
              {{loadingMessage}}
            </v-flex>
          </div>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    projectTitle() {
      return this.$store.state.app.projectTitleLong
    },
    loadingMessage() {
      return this.$store.state.app.initMessage
    },
    loading() {
      if (this.$store.state.app.init === 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    reloadPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.splashPage {
  background: url("/static/img/login-bg.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  .splashInnerPnl {
    text-align: center;
    width: 40%;
  }
}

h2 {
  font-size: 2.3em;
  font-weight: 500;
}
</style>
